import { localize } from 'mixins/helpers';

export const renderColumns = (props:any) => {
 return [
  {
    title: localize('find-admitted-for-exam-fullname', props.translations),
    dataIndex: "fio",
  },
  {
    title: localize('find-admitted-for-exam-date', props.translations),
    dataIndex: "localDate",
    render: localDate => localDate && localDate.split("-").reverse().join(".")
  },
  {
    title: localize('find-admitted-for-exam-start', props.translations),
    dataIndex: "localTime",
    render: localTime => localTime && localTime.substring(0, 5)
  },
  {
    title: localize('find-admitted-for-exam-location', props.translations),
    dataIndex: "location",
  },
];
};
